// Traspaso «nota -> Centro de Llamadas». Dos caminos, una sola entrega:
//  (A) el Centro YA está abierto (otra pestaña/ventana del mismo navegador): la nota guarda la entrega y AVISA (BroadcastChannel; respaldo: el
//      evento `storage` de localStorage, y una llamada directa si es la misma pestaña). El aviso NO lleva datos: solo despierta a quien escucha.
//  (B) el Centro NO está abierto: la entrega queda guardada y se recoge al montarse (mismo guardarPrecarga/tomarPrecarga de lib/notas).
// La entrega vive en localStorage con DUEÑO (id de la persona) y caducidad (PRECARGA_TTL_MS): otra persona del mismo navegador nunca la recibe.
// Tomarla es de un solo uso (y con candado de navegador si existe) para que dos pestañas del Centro no la apliquen las dos.
import { guardarPrecarga, verPrecarga, tomarPrecarga, PRECARGA_KEY } from "./notas";

export const TRASPASO_CANAL = "cx-traspaso-llamada";
export const TRASPASO_LOCK = "cx-traspaso-llamada";
/** Solo una entrega FRESCA arranca la llamada sola; una más vieja deja el número puesto y espera un clic (nunca llama por algo de hace rato). */
export const TRASPASO_AUTO_MS = 2 * 60 * 1000;

const oyentes = new Set();
let canal = null;   // null = sin abrir; false = no disponible

function avisar() { Array.from(oyentes).forEach((fn) => { try { fn(); } catch (e) { /* un oyente roto no frena a los demás */ } }); }
function abrirCanal() {
  if (canal !== null) return canal || null;
  try {
    canal = typeof BroadcastChannel === "function" ? new BroadcastChannel(TRASPASO_CANAL) : false;
    if (canal) canal.onmessage = () => avisar();
  } catch (e) { canal = false; }
  return canal || null;
}
function alStorage(e) { if (e && e.key === PRECARGA_KEY && e.newValue) avisar(); }

/** Guarda la entrega (con dueño y hora) y avisa a los Centros abiertos. Sin dueño conocido no guarda nada ni avisa. */
export function emitirTraspaso(data) {
  guardarPrecarga(data);
  if (!verPrecarga()) return false;
  const c = abrirCanal();
  try { if (c) c.postMessage({ tipo: "traspaso", at: Date.now() }); } catch (e) { /* el respaldo es el evento storage */ }
  avisar();
  return true;
}

/** `fn()` se llama cuando llega (o puede haber llegado) una entrega. Devuelve la función para dejar de escuchar. */
export function suscribirTraspaso(fn) {
  abrirCanal();
  if (oyentes.size === 0 && typeof window !== "undefined" && window.addEventListener) window.addEventListener("storage", alStorage);
  oyentes.add(fn);
  return () => {
    oyentes.delete(fn);
    if (oyentes.size === 0 && typeof window !== "undefined" && window.removeEventListener) window.removeEventListener("storage", alStorage);
  };
}

/** ¿Hay una entrega mía, vigente, esperando? (no la consume) */
export const haySolicitudPendiente = () => !!verPrecarga();

/** Toma la entrega (un solo uso). Con navigator.locks, dos pestañas del Centro no pueden tomar la misma. */
export function tomarTraspaso() {
  const locks = typeof navigator !== "undefined" ? navigator.locks : null;
  if (locks && typeof locks.request === "function") return locks.request(TRASPASO_LOCK, () => tomarPrecarga()).catch(() => null);
  return Promise.resolve(tomarPrecarga());
}

export const traspasoEsFresco = (pre, now = Date.now()) => !!pre && now - Number(pre.at) <= TRASPASO_AUTO_MS;
